import styles from '../../../../styles/automationStudio/automationStudio.module.scss';

/**
 * Accessible tab list using native buttons (replaces MUI Tabs/Tab).
 * @param {number|string} value - active tab value (must match item.value)
 * @param {(next: number|string) => void} onChange
 * @param {{ value: number|string, label: React.ReactNode, disabled?: boolean }[]} items
 */
export default function NativeTabBar({ value, onChange, items = [] }) {
    return (
        <div className={styles.tabs} role="tablist">
            {items.map((item) => (
                <button
                    key={String(item.value)}
                    type="button"
                    role="tab"
                    aria-selected={value === item.value}
                    disabled={item.disabled}
                    className={`${styles.tab} ${value === item.value ? styles.tabSelected : ""}`}
                    onClick={() => onChange(item.value)}
                >
                    {item.label}
                </button>
            ))}
        </div>
    );
}
